/*
=========================================================
* Material Kit 2 React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Material Kit 2 React examples
import DefaultNavbar from "bachrosenComponents/bachNavbar";
import CenteredFooter from "bachrosenComponents/centeredFooter";
import BachCenteredBlogCard from "bachrosenComponents/bachCenteredBlogCard";
import BachHeader from "bachrosenComponents/bachHeader";

// Routes
import routes from "routes";
import footerRoutes from "footer.routes";

// Images
// import bgImage from "assets/images/home1.jpg";
import bgImage from "assets/images/gruppierungen-gruppenbild.jpg";
import imgBachrosen from "assets/images/gruppierungen-bachrosen.jpg";
import imgElferrat from "assets/images/gruppierungen-elferrat.jpg";
import imgGaertner from "assets/images/gruppierungen-gaertner.jpg";
// import imgGruppenbild from "assets/images/gruppierungen-gruppenbild.jpg";
import imgGruppenbild2 from "assets/images/gruppierungen-gruppenbild2.jpg";
import imgNarreneltern from "assets/images/gruppierungen-narreneltern.jpg";

function GroupingsSite() {
  return (
    <MKBox component="header" position="relative" height="100%">
      <MKBox position="fixed" top="0.5rem" width="100%">
        <DefaultNavbar routes={routes} dark info center />
      </MKBox>
      <BachHeader image={bgImage} title="Gruppierungen" />
      {/* <MKBox
        minHeight="75vh"
        width="100%"
        sx={{
          backgroundImage: ({ functions: { linearGradient, rgba }, palette: { gradients } }) =>
            `${linearGradient(
              rgba(gradients.dark.main, 0.6),
              rgba(gradients.dark.state, 0.6)
            )}, url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "grid",
          placeItems: "center",
        }}
      >
        <MKTypography
          align="center"
          variant="h1"
          color="white"
          sx={({ breakpoints, typography: { size } }) => ({
            [breakpoints.down("md")]: {
              fontSize: size["3xl"],
            },
          })}
        >
          Gruppierungen
        </MKTypography>
      </MKBox> */}
      <Card
        sx={{
          // p: 2,
          mx: { xs: 2, lg: 3 },
          mt: -8,
          mb: 4,
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >
        <Container>
          <Grid
            container
            spacing={3}
            direction="column"
            alignItems="center"
            justifyContent="center"
            mt={2}
            mb={8}
          >
            {/* <Grid item xs={12} lg={6} mt={8}>
              <BachCenteredBlogCard
                image={imgGruppenbild}
                title="                     "
                description="                    "
              />
            </Grid> */}
            <Grid item xs={12} lg={6} mt={8}>
              <BachCenteredBlogCard
                image={imgGruppenbild2}
                title="Gruppenbild"
                description="Eine kleine Übersicht aller Figuren, die bei uns an der Fasnet vertreten sind."
              />
            </Grid>
            <Grid item xs={12} lg={6} mt={8}>
              <MKBox>
                <BachCenteredBlogCard
                  image={imgElferrat}
                  title="Elferrat mit Bolizist"
                  description="Die Mitglieder im Elferrat werden versetzt alle zwei Jahre an der Generalversammlung neu gewählt. <br>
                  Der Elferrat stellt die Vorstandschaft der Narrenzunft dar und übernimmt die Verwaltung und Organisation des Zunftlebens. <br>
                  Der Bolizist schaut, dass alles mit rechten Dingen zugeht."
                />
              </MKBox>
            </Grid>
            <Grid item xs={12} lg={6} mt={8}>
              <BachCenteredBlogCard
                image={imgBachrosen}
                title="Bachrosen"
                description="Unsere Bachrosen verteilen Guetzle aus ihren Körben. Unter ihnen gibt es eine Bachrosenvertretung."
              />
            </Grid>
            <Grid item xs={12} lg={6} mt={8}>
              <BachCenteredBlogCard
                image={imgGaertner}
                title="Gärtner"
                description="Unsere Gärtner schmeißen mit Narrensamen um sich. Unter ihnen gibt es eine Gärtnervertretung."
              />
            </Grid>
            <Grid item xs={12} lg={6} mt={8} max-height={100}>
              <BachCenteredBlogCard
                image={imgNarreneltern}
                title="Narreneltern"
                description="Unsere Narreneltern sorgen sich um unsere Narrensamen."
              />
            </Grid>
          </Grid>
        </Container>
      </Card>
      <MKBox px={1} mt={6}>
        <CenteredFooter content={footerRoutes} />
      </MKBox>
    </MKBox>
  );
}

export default GroupingsSite;
